(function() { module.exports = window[undefined]; }());


//////////////////
// WEBPACK FOOTER
// external {"umd":"Vue","global":"Vue","root":"Vue","commonjs2":"vue","commonjs":"vue","amd":"vue"}
// module id = 35
// module chunks = 0